import { createContext } from "react";

import { PatientDemographicHelper } from "./PatientDemographicHelper.ts";

export const PatientDemographicContext =
  createContext<PatientDemographicHelper>({} as PatientDemographicHelper);
